import { useEffect } from 'react'
interface MagicModalProps {
  children: React.ReactNode
  modalId: string
  targetId: string
  showModal: boolean
  onCloseModal: () => void
  width?: number
  height?: number
}
export const MagicModal: React.FC<MagicModalProps> = ({
  children,
  modalId,
  targetId,
  showModal,
  onCloseModal,
  width = 900,
  height = 650
}) => {
  useEffect(() => {
    const modal = document.getElementById('magicModal-' + modalId)
    const targetRect = document
      ?.getElementById(targetId)
      ?.getBoundingClientRect()

    if (modal && targetRect) {
      modal.style.top = targetRect.top + 'px'
      modal.style.left = targetRect.left + 'px'
      modal.style.width = targetRect.width + 'px'
      modal.style.height = targetRect.height + 'px'
    }
  }, [targetId])

  const onShow = () => {
    const modal = document.getElementById('magicModal-' + modalId)
    const targetRect = document
      ?.getElementById(targetId)
      ?.getBoundingClientRect()
    if (modal && targetRect) {
      modal.style.top = targetRect.top + 'px'
      modal.style.left = targetRect.left + 'px'
      modal.style.width = targetRect.width + 'px'
      modal.style.height = targetRect.height + 'px'

      const windowWidth = window.innerWidth
      const windowHeight = window.innerHeight
      modal.style.top = (windowHeight - height) / 2 + 'px'
      modal.style.left = (windowWidth - width) / 2 + 'px'
      modal.style.width = width + 'px'
      modal.style.height = height + 'px'
    }
  }

  const onClose = () => {
    const modal = document.getElementById('magicModal-' + modalId)
    const targetRect = document
      ?.getElementById(targetId)
      ?.getBoundingClientRect()
    if (modal && targetRect) {
      modal.style.top = targetRect.top + 'px'
      modal.style.left = targetRect.left + 'px'

      modal.style.width = targetRect.width + 'px'
      modal.style.height = targetRect.height + 'px'
    }
  }

  useEffect(() => {
    if (showModal) {
      onShow()
    } else {
      onClose()
    }
  }, [showModal])

  return (
    <>
      {showModal && (
        <div
          onClick={() => {
            onCloseModal()
          }}
          className={
            'fixed inset-0 z-[900] bg-slate-700/10 backdrop-blur transition-all' +
            (showModal ? 'opacity-100' : 'opacity-0')
          }
        />
      )}
      <div
        id={'magicModal-' + modalId}
        className={
          ' z-[9999] fixed transition-all ease-in duration-300 rounded-3xl bg-white shadow-2xl ' +
          (showModal ? 'visible opacity-100' : 'invisible opacity-0')
        }
      >
        {children}
      </div>
    </>
  )
}
export default MagicModal
